<template>
  <ModalWrapper
    class="z-header-overlay"
    @close-modal="$emit('close')"
  >
    <div class="p-24 pt-32">
      <div>
        {{ $lang('product_page', 'gift_card_alert_text') }}
      </div>
      <ButtonComponent
        :loading="loading"
        is-block
        class="w-full mt-16"
        :is-danger-btn="true"
        :text="$lang('product_page', 'gift_card_alert_clear_cta')"
        @click="$emit('clear')"
      />
      <ButtonComponent
        is-block
        :is-secondary-btn="true"
        class="w-full mt-16"
        :text="$lang('product_page', 'gift_card_alert_abort_cta')"
        @click="$emit('close')"
      />
    </div>
  </ModalWrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ModalWrapper from '~/components/global/ModalWrapper.vue';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
export default defineComponent({
  components: { ButtonComponent, ModalWrapper },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close', 'clear'],
});
</script>
